var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Man-CF7MenuPrincipal"},[_c('PageTitle',{attrs:{"icon":"fa fa-shopping","main":"CF7","sub":"STORE consulta de vales em aberto "}}),_c('div',{staticClass:"Man-CF7MenuPrincipal"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Parcelas","active":""}},[_c('FuncionarioParcelas')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }